import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAgreementView',
  setup(__props) {

const rawHtml = ref('');

const processedHtml = computed(() => {
  if (!rawHtml.value) return '';
  
  // 创建一个临时的 DOM 解析器
  const parser = new DOMParser();
  const doc = parser.parseFromString(rawHtml.value, 'text/html');
  
  // 提取 body 中的内容
  const content = doc.body.innerHTML;
  
  return content;
});

onMounted(async () => {
  try {
    const response = await fetch('/user_agreement.html');
    rawHtml.value = await response.text();
  } catch (error) {
    console.error('Failed to load user agreement:', error);
    rawHtml.value = '<p>Failed to load user agreement.</p>';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "user-agreement-content",
        innerHTML: processedHtml.value
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})